<template>
  <div class="modal" id="modalManageBooking">
    <div class="modal-dialog bg-light" style="background: #fff;">
      <div class="modal-header border-0 pb-0">
        <div class="modal-title mt-1">
          <h5 class="font-weight-bold mb-1">Manage Existing Booking</h5>
          <p>No registration required</p>
        </div>
        <button type="button" id="btn_close_managebooking" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-content border-0">
        <!-- Modal body -->
        <div class="modal-body pt-0 pb-4 bg-light">
          <div class="row">
            <div class="col-md-7 order-2 order-md-1">
              <input v-model="reference" type="text" placeholder="Booking Reference" class="form-control">
              <div class="" v-if='$v.reference.$error' :class='{ "form__input-error": $v.reference.$error }'>
                Please enter a reference
              </div>
              <input v-model="email" type="email" placeholder="Your email address" class="form-control mt-3">
              <div class="" v-if='$v.email.$error' :class='{ "form__input-error": $v.email.$error }'>
                Please enter your email
              </div>
              <div v-if="email !== ''">
                <div class="form__input-error" v-if='!$v.email.email'>
                    This email is not valid
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <button type="success" class="btn btn-sm btn-orange-solid mt-3" @click.prevent="manageBookingFetch">
                  <div v-show="isSearching">
                    <span v-html="manageSearchSpinner"></span>
                  </div>
                  <div v-show="!isSearching">GO</div>
                </button>
              </div>
            </div>
            <div class="col-md-5 pt-0 pb-3 order-1 order-md-2">
              <ul style="list-style: none;">
                <li class="mt-0">
                  Change dates
                </li>
                <li class="mt-2">
                  Edit guest details
                </li>
                <li class="mt-2">
                  Change rooms
                  </li>
                <li class="mt-2">
                  Cancel booking
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import manageBooking from '../../mixins/manageBooking'
import reusableData from '../../mixins/reusableData'
import { required, email } from 'vuelidate/lib/validators'

export default {
  components: {
  },
  props: {
  },
  data () {
    return {
      reference: '',
      email: '',
      bookingDetails: '',
      formData: [],
      isSearching: false,
      manageSearchSpinner: "<i class='fa fa-spinner fa-spin'></i> SEARCHING"
    }
  },
  validations: {
    reference: { required },
    email: { required, email }
  },
  methods: {
    manageBookingFetch () {
      this.$v.$touch()
      if (this.reference !== '' && this.email !== '' && !this.$v.$invalid) {
        this.getUrlData()
        this.fetchBookingData()
      }
    },
    closeModal () {
      document.getElementById('btn_close_managebooking').click()
    }
  },
  mixins: [manageBooking, reusableData]
}
</script>

<style>
.max_whalf {
  max-width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/manageBooking/subcomponents/Modal.vue